export default "__VITE_ASSET__nkatv2cr__"